module.exports = __webpack_public_path__ + "img/information_ethical.6de7a88.webp";